import React from "react";
import { QuizObjectFact } from "../../../../../../store/modquiz/quiz_objects/quiz-object";
import EditableCell from "./EditableCell";
import { observer } from "mobx-react";
import Button from "@mui/material/Button";

interface FactRowProps {
    fact: QuizObjectFact;
    rowNumber: number;
    onDelEvent: Function;
    onUnDelEvent: Function;
    focusField: Function;
    blurField: (event: React.FocusEvent<HTMLInputElement>) => void;
    onFactTableUpdate: (
        event: React.ChangeEvent<HTMLInputElement>,
        factID: string,
        order: number
    ) => void;
}

let FactRow = observer(
    ({
        fact,
        onDelEvent,
        onUnDelEvent,
        onFactTableUpdate,
        blurField,
        focusField,
        rowNumber
    }: FactRowProps) => {
        let onClickDel = () => {
            onDelEvent(fact);
        };

        let onClickUnDel = () => {
            onUnDelEvent(fact);
        };

        return (
            <tr className={"eachRow " + (fact.deleted ? "deleted" : "")}>
                <EditableCell
                    onFactTableUpdate={ev =>
                        onFactTableUpdate(ev, fact._id, fact.order)
                    }
                    cellData={{
                        type: `name-${fact._id}`,
                        value: fact.name,
                        id: fact._id
                    }}
                    rowNumber={rowNumber}
                    blurField={blurField}
                    focusField={focusField}
                />
                <EditableCell
                    onFactTableUpdate={ev =>
                        onFactTableUpdate(ev, fact._id, fact.order)
                    }
                    cellData={{
                        type: `value-${fact._id}`,
                        value: fact.value,
                        id: fact._id
                    }}
                    rowNumber={rowNumber}
                    blurField={blurField}
                    focusField={focusField}
                />
                <td className="del-cell">
                    {fact.deleted ? (
                        <Button
                        type="button"
                        color="primary"
                        variant="contained"
                        onClick={onClickDel}
                        title="Restore Fact"
                        className="del-btn"
                        >Undo</Button>
                ) : (
                        <Button
                            type="button"
                            color="secondary"
                            onClick={onClickDel}
                            className="del-btn"
                            title="Delete Fact"
                        >X</Button>
                    )}
                </td>
            </tr>
        );
    }
);

export default FactRow;
